// extracted by mini-css-extract-plugin
export var locationCard = "_eh-0";